import { KeyedMutator } from 'swr';
import { IDeal, IDealSummary } from '../../interfaces';

export type CoBorrowerProps = {
  contactId?: string;
  dealData?: IDeal;
  reloadDeal?: KeyedMutator<IDeal>;
  refreshDealsTable?: KeyedMutator<IDealSummary[]>;
};

export interface IName {
  firstName: string;
  lastName: string;
  contactId: string;
}

export interface INamesList {
  totalCount: number;
  items: IName[];
}

export enum RelationshipEnum {
  'Spousal' = 1,
  'Parent',
  'Child',
  'Friend',
  'FamilyOther',
  'None',
}
